module.exports = __webpack_public_path__ + "static/media/P1000-Plunger.bacc5f3d.svg";